// Orders in these states have no confirmed payment, so there is nothing to put on a receipt
export const NO_RECEIPT_STATUSES = ["pending", "failed", "cancelled", "amount_mismatch"];

export const canShowReceipt = (order) =>
  Boolean(order) && !NO_RECEIPT_STATUSES.includes(order.status);

// Customer-friendly wording for each status
const CUSTOMER_LABELS = {
  pending: "Awaiting payment",
  paid: "Paid",
  delivered: "Delivered",
  failed: "Payment failed",
  cancelled: "Cancelled",
  amount_mismatch: "Under review",
};

export const customerStatusLabel = (status) =>
  CUSTOMER_LABELS[status] ??
  (status ? status.charAt(0).toUpperCase() + status.slice(1) : "Unknown");

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" })
    : "";

export const formatMoney = (n) => `£${Number(n).toFixed(2)}`;

export const orderItems = (order) => (Array.isArray(order?.items) ? order.items : []);